// Homepage benetics JS logic

  (function() {
    const triggers = document.querySelectorAll('.onpulse-feature-card[data-modal]');
    const modals = document.querySelectorAll('.onpulse-feature-modal');
    const closeButtons = document.querySelectorAll('[data-close-modal]');
    const slider = document.getElementById('onpulseFeaturesSlider');
    const dotsWrap = document.getElementById('onpulseFeaturesDots');

    let startX = 0;
    let startY = 0;
    let moved = false;

    function openModal(id) {
      const modal = document.getElementById(id);
      if (!modal) return;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('onpulse-modal-open');
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('onpulse-modal-open');
    }

    triggers.forEach(trigger => {
      trigger.addEventListener('pointerdown', function(e) {
        startX = e.clientX;
        startY = e.clientY;
        moved = false;
        this.classList.add('is-tapped');
      }, { passive: true });

      trigger.addEventListener('pointermove', function(e) {
        const diffX = Math.abs(e.clientX - startX);
        const diffY = Math.abs(e.clientY - startY);
        if (diffX > 8 || diffY > 8) moved = true;
      }, { passive: true });

      trigger.addEventListener('pointerup', function() {
        window.setTimeout(() => this.classList.remove('is-tapped'), 140);
      }, { passive: true });

      trigger.addEventListener('pointercancel', function() {
        this.classList.remove('is-tapped');
        moved = true;
      }, { passive: true });

      trigger.addEventListener('click', function(e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
          return;
        }
        openModal(this.getAttribute('data-modal'));
      });

      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openModal(this.getAttribute('data-modal'));
        }
      });
    });

    closeButtons.forEach(button => {
      button.addEventListener('click', function() {
        closeModal(this.closest('.onpulse-feature-modal'));
      });
    });

    modals.forEach(modal => {
      modal.addEventListener('click', function(e) {
        if (e.target === modal) closeModal(modal);
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        modals.forEach(modal => {
          if (modal.classList.contains('is-open')) closeModal(modal);
        });
      }
    });

    if (slider && dotsWrap) {
      const dots = dotsWrap.querySelectorAll('.onpulse-features__dot');
      const cards = slider.querySelectorAll('.onpulse-feature-card');
      let ticking = false;

      function setActiveDot(index) {
        dots.forEach(dot => dot.classList.remove('is-active'));
        if (dots[index]) dots[index].classList.add('is-active');
      }

      function getActiveIndex() {
        if (!cards.length) return 0;
        const cardWidth = cards[0].offsetWidth + 14;
        const index = Math.round(slider.scrollLeft / cardWidth);
        return Math.max(0, Math.min(index, cards.length - 1));
      }

      function updateDots() {
        setActiveDot(getActiveIndex());
        ticking = false;
      }

      slider.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(updateDots);
          ticking = true;
        }
      }, { passive: true });

      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function() {
          if (!cards[index]) return;
          const targetLeft = cards[index].offsetLeft - 18;
          slider.scrollTo({ left: targetLeft, behavior: 'smooth' });
          setActiveDot(index);
        });
      });

      setActiveDot(0);
    }
  })();
